import "./App.css";

// import logo from "./logo.png";

import ECommerse from "./E-Commerse";


function App() {
  return (
    <div className="App">
      <ECommerse/>    
    </div>
  );
}

export default App;
